module.exports = __webpack_public_path__ + "img/app-screenshots.4538f07b.png";